import { useEffect, useState, useCallback } from "react";
import "./FlipCard.css";


function App3(props) {
  return (
    <>
      <div className="the-card">
        <div className="front">
          <img src={props.imgsrc} className="flip-img" width="250px" height="150px" />
          <h1 className="content-front"> {props.front}</h1>
        </div>
        <div className="back">
          <div className="back-content">
          <p className="content-back">Organiser: {props.organiser}</p>
          <p className="content-back">Date: {props.date}</p>
          <p className="content-back">Time: {props.time}</p>
          <p className="content-back">Place: {props.place}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default App3;
